module.exports = "/images/br.svg?6b2fd790bc1235c227cd5b23bacc7bfd";